<template>
  <div ref="root">
    <div
      v-for="filter in filters.list"
      :key="filter.label"
      role="region"
      class="filter-container"
      aria-label="filters with selected terms"
      @keydown="keyDownHandler"
    >
      <button
        class="filter-trigger btn"
        aria-controls="filter-list-container"
        aria-expanded="false"
        aria-labelledby="label value"
        @click="toggleFilterList"
      >
        <span class="value" id="value">{{ filter.label }}</span>
      </button>
      <div
        id="filter-list-container"
        class="filter-list-container"
        role="region"
        aria-label="term filter"
      >
        <div class="sr-only">
          The following text field filters the results that follow as you type.
          Use Tab to access the results.
        </div>
        <div class="results-count sr-only" aria-live="assertive"></div>
        <ul class="filter-list">
          <li v-for="term in filter.terms" :key="term.id">
            <label :for="term.slug">{{ term.name }}</label>
            <input
              type="checkbox"
              :value="term.term_id"
              :id="term.slug"
              @click="updateTerms(filter.taxonomy, term.term_id, $event)"
            />
          </li>
        </ul>
      </div>
      <div
        class="filter-results"
        role="region"
        aria-label="Selected terms"
      ></div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";

export default {
  props: ["filters"],
  setup(props, context) {
    const root = ref(null);
    const filters = reactive(props.filters);

    onMounted(() => {
      console.log("root", root.value);
    });

    const toggleFilterList = (e) => {
      const isExpanded = e.currentTarget.getAttribute("aria-expanded");

      e.currentTarget.setAttribute(
        "aria-expanded",
        isExpanded === "true" ? false : true
      );
    };

    const updateTerms = (taxonomy, term_id, e) => {
      console.log(term_id, e.currentTarget.checked);
      context.emit("update-filters", {
        taxonomy,
        term_id,
        selected: e.currentTarget.checked,
      });
    };

    /**
     * UX and a11y
     */
    // Collapse the dropdown container when Escape key is pressed.
    const keyDownHandler = (e) => {
      const trigger = e.currentTarget.querySelector('.filter-trigger');

      var isExpanded =
        trigger.getAttribute("aria-expanded") === "true" ? true : false;

      if (e.key === "Escape" && isExpanded) {
        trigger.setAttribute("aria-expanded", false);
        trigger.focus();
      }
    }

    // Collapse the dropdown container when outside of the filter container clicked
    document.addEventListener("click", (e) => {
      const triggers = root.value.querySelectorAll(".filter-trigger");

      triggers.forEach((trigger) => {
        const isExpanded =
          trigger.getAttribute("aria-expanded") === "true" ? true : false;

        if (
          !trigger.nextSibling.contains(e.target) &&
          !trigger.contains(e.target) &&
          trigger != e.target &&
          isExpanded
        ) {
          trigger.setAttribute("aria-expanded", false);
        }
      });
    });

    return {
      root,
      filters,
      updateTerms,
      toggleFilterList,
      keyDownHandler,
    };
  },
};
</script>
